import { createAction, props } from '@ngrx/store';
import { ProductDataForBar } from './compare-products.models';

export const addProductDataForBar = createAction(
  'Add Product Data For Bar',
  props<{ productDataForBar: ProductDataForBar }>()
);

export const removeProductFromComparison = createAction('Remove Product From Compare', props<{ productId: string }>());

export const removeAllProductsFromComparison = createAction('Remove all products from comparison');
